import { Component, OnInit } from "@angular/core";
import * as paper from "paper";

@Component({
  selector: "app-image-canvas",
  styleUrls: ["./image-canvas.view.component.scss"],
  template: `<img id="selfie" src="/src/assets/images/selfie.jpg" /><canvas id="image-canvas"></canvas>`,
})
export class ImageCanvasComponent implements OnInit {

  public ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/views/home/image-canvas/image-canvas.view.component.ts